import React from "react";
import { NavLink } from "react-router-dom";

interface HeaderLinkProps {
  title: string;
  link: string;
}
let activeClass = "text-sky-600 dark:text-white underline";
let inactiveClass = "";
let baseClass = "hover:text-sky-600 cursor-pointer ";

const HeaderLink = (props: HeaderLinkProps) => {
  return (
    <li>
      <NavLink
        to={props.link}
        className={({ isActive }) =>
          isActive ? baseClass + activeClass : baseClass + inactiveClass
        }
      >
        {props.title}
      </NavLink>
    </li>
  );
};

export default HeaderLink;
